(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Re-measure once everything (including the async-loaded stylesheets Dawn defers
      // via the media="print" trick, and web fonts) has actually finished — connectedCallback
      // fires as soon as the browser parses this far into the HTML, which can be before
      // the announcement bar's own CSS has been applied yet. Measuring .offsetHeight that
      // early can capture its un-styled height (often far shorter than its real rendered
      // height), setting --announcement-bar-height too small — and since nothing
      // previously re-measured after that point (only the breakpoint-change listener
      // below did), a wrong early reading stuck around permanently. That's what let the
      // hero-overlay header (position:fixed; top: var(--announcement-bar-height)) render
      // high enough to overlap the announcement bar instead of sitting below it.
      window.addEventListener('load', this.setHeaderHeight);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // The hero-overlay header is fixed to the viewport (see the :has(.banner--full_screen)
      // rule in the style block above), which otherwise pins it at the literal top of the
      // viewport — exactly where the announcement bar, a separate normal-flow section,
      // already sits. Offsetting by its real height (not a guessed constant, since it
      // varies with text length) keeps them stacked instead of overlapping.
      var announcementBar = document.querySelector('.announcement-bar-section');
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${announcementBar ? announcementBar.offsetHeight : 0}px`
      );
    }

    disconnectedCallback() {
      window.removeEventListener('load', this.setHeaderHeight);
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // --header-height is also set inside StickyHeader above, but that class only exists
  // when sticky_header_type isn't "none" — on templates where sticky is intentionally
  // disabled (product pages), that element never renders, so the variable never got set
  // at all and fell back to whatever default a consumer happened to use, which is what
  // broke the mobile drawer's height (it covered the whole screen, including the close
  // button, because it assumed the header had zero height). This runs independently of
  // sticky status so the variable is always reliable wherever it's used.
  (function () {
    function setHeaderHeight() {
      var header = document.querySelector('.section-header');
      if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);

      // Drawer top/height are NOT set here — Dawn's own HeaderDrawer.openMenuDrawer()
      // (global.js) already sets --header-bottom-position and --viewport-height from
      // getBoundingClientRect() at the exact moment the drawer opens, which the drawer's
      // default CSS (top: 100%; height: calc(var(--viewport-height) - var(--header-bottom-position)))
      // already consumes correctly. An earlier version of this function also set
      // drawer.style.top/height directly from a page-load-time offsetHeight estimate,
      // which is less accurate (doesn't account for scroll position or sticky state at
      // open-time) and was overriding Dawn's correct values with an inline style — that's
      // what caused a visible gap between the header and the drawer's menu items.
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('load', setHeaderHeight);
  })();

  } catch(e) { console.error(e); }
})();
})();
